export default __webpack_public_path__ + "static/media/2 Foundational Core  Pelvic Floor Videos.d6aa08c6.webp";